import styled from "styled-components";

const Badge = styled.span`
  font-size: ${props => props.bold === true ? `0.7em` : `0.6em`};
  color: ${props => props.color ? props.color : '#ff0000'};
  padding-left: 10px;
  text-transform: uppercase;
  font-weight: ${props => props.bold === true ? `600` : `normal`};
`;

export default Badge;
